<template>
  <div class="form">
    <div class="form__content">
      <IdentityQueueStepCounter />
      <h1 class="extra-large-headline">
        {{ $t("PageTitle.headline.occupationTitle") }}
      </h1>
    </div>
    <form @submit.prevent>
      <OccupationField @inputValueUpdate="updateOccupation" />

      <ButtonBase
        :isDisabled="
          occupationStore.formHasErrors || globalStore.getIsFormLoading
        "
        :isLoading="globalStore.getIsFormLoading"
        @onButtonClick="handleFormSubmit"
      >
        {{ $t("ButtonBase.label.submitMyDetails") }}
      </ButtonBase>
      <IdentityQueueNext />
    </form>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { useRoute, useRouter } from "vue-router";

import { useGlobalStore } from "@/stores/globalStore";
import { useOccupationStore } from "@/stores/forms/occupationFormStore";
import { useIdentityQueueStore } from "@/stores/identityQueueStore";

import useApiHelpers from "@/composables/api/helpers";
import useCustomerActions from "@/composables/api/useCustomerActions";

import ButtonBase from "@/components/ui/buttons/ButtonBase.vue";
import OccupationField from "@/components/ui/inputs/OccupationField.vue";
import IdentityQueueStepCounter from "@/components/layout/progress/IdentityQueueStepCounter.vue";
import IdentityQueueNext from "@/components/layout/progress/IdentityQueueNext.vue";

const route = useRoute();
const router = useRouter();
const globalStore = useGlobalStore();
const occupationStore = useOccupationStore();

const { postRequest } = useApiHelpers();
const { fetchCustomerId } = useCustomerActions();
const identityQueueStore = useIdentityQueueStore();

const form = ref({
  occupation: occupationStore.form.occupation.value || "",
});

const updateOccupation = (inputData) => {
  const field = Object.keys(inputData)[0];
  const value = Object.values(inputData)[0];

  form.value[field] = value;
};

const handleFormSubmit = async () => {
  const formData = {
    documentType: "occupation",
    occupation: form.value.occupation,
  };

  globalStore.setIsFormLoading(true);

  postRequest("customers/occupation", formData, () => {
    identityQueueStore.updateToNextRoute();
    identityQueueStore.fetchNextIdentityRoute(route).then((nextRoute) => {
      router.push(nextRoute);
    });
  });
};
</script>
<style lang="scss" scoped>
.form {
  .bodycopy {
    margin-bottom: 1rem;
    @include breakpoint($min-m) {
      margin-bottom: 1.5rem;
    }
  }
  &__selfie-instructions {
    list-style: unset;
    padding-inline: 1.5rem;

    li {
      font-size: $font-body;
      line-height: 1.5;
    }
  }
}
</style>
